<template>
  <div>
    <v-row>
      <v-toolbar flat>
        <v-toolbar-title>
          <v-row>
            <v-col>
              <div
                style="background-color: #33304f; color: white"
                class="px-2 rounded"
                @click="debugInfo()"
              >
                {{ customers.length }} {{ trad.Customers }}
              </div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-spacer></v-spacer>
        <v-btn
          color="#33304f"
          dark
          class="mb-2"
          fab
          small
          @click="addCustomer()"
          :disabled="readOnly"
        >
          <v-icon> mdi-plus </v-icon>
        </v-btn>
      </v-toolbar>

      <v-col cols="12">
        <div v-if="loadingData" style="text-align: center">
          <v-progress-linear
            color="cyan"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </div>
      </v-col>
      <v-col cols="12" class="my-n7">
        <v-data-table
          dense
          :headers="customersHeaders"
          :items="customers"
          class="elevation-1"
          :loading="loadingTable"
          hide-default-footer
          :footer-props="{
            'items-per-page-options': [-1],
          }"
          @click:row="clickRowCustomers"
          :no-data-text="trad.NoData"
          :loading-text="trad.Loading"
        >
          <template v-slot:item="{ index, item }">
            <tr @click="clickRowCustomers(index, item)">
              <td>
                <v-row>
                  <v-col cols="2" style="margin-top: 4px; margin-bottom: 8px">
                    <v-text-field
                      v-model="item.firstName"
                      :label="trad.FirstName"
                      class="mb-n3"
                      :disabled="readOnly"
                      :background-color="item.firstName ? '' : '#fdbdbd'"
                    ></v-text-field>

                    <v-text-field
                      style="margin-top: 1px"
                      v-model="item.lastName"
                      :disabled="readOnly"
                      :label="trad.LastName"
                      class="mb-n2"
                      :background-color="item.lastName ? '' : '#fdbdbd'"
                    ></v-text-field>

                    <v-btn
                      color="error"
                      dark
                      class="ml-2 pb-n2"
                      fab
                      x-small
                      @click="deleteCustomer(index)"
                      :disabled="readOnly"
                    >
                      <v-icon> mdi-delete </v-icon>
                    </v-btn>
                  </v-col>

                  <v-col cols="10">
                    <!-- START Linia 1 -->

                    <v-row style="height: 96px" class="mb-n8" v-if="j_model">
                      <v-col
                        :cols="womens ? 1 : 2"
                        style="
                          color: #803135;
                          font-size: 16px;
                          font-weight: bold;
                        "
                        class="my-3 mr-0 ml-4"
                      >
                        {{ trad.JACKET }}
                      </v-col>

                      <!-- START JACKET QUANTITY QTY -->
                      <v-col>
                        <div
                          class="mt-1 ml-6"
                          style="border: 2px solid #803135; width: 90px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.Quantity }}
                          </div>

                          <div>
                            <input
                              v-model="item.j_qty"
                              :disabled="readOnly"
                              @change="corporateChanged"
                              type="number"
                              min="0"
                              max="9999"
                              style="
                                width: 100%;
                                text-align: center;
                                padding-left: 17px;
                                font-weight: bold;
                              "
                              :style="
                                item.j_qty > 0 && item.j_qty < 10000
                                  ? ''
                                  : 'background-color: #fdbdbd;'
                              "
                            />
                          </div>
                        </div>
                      </v-col>
                      <!-- END JACKET QUANTITY QTY -->

                      <!-- START JACKET SIZE -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.SIZE }}
                          </div>

                          <div
                            style="
                              width: 110px;
                              height: 25px;
                              text-align: center;
                              font-weight: bold;
                            "
                          >
                            <v-select
                              v-model="item.j_size"
                              :items="j_sizeArray"
                              single-line
                              dense
                              label="-"
                              type="number"
                              class="ml-10 my-n1"
                              @change="selectSizeJ(item, index)"
                              :disabled="readOnly"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                      <!-- END JACKET SIZE -->

                      <!-- START WOMENS JACKET CHEST -->
                      <v-col v-if="womens">
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.CHEST }}
                          </div>

                          <div
                            style="
                              width: 110px;
                              height: 25px;
                              text-align: center;
                              font-weight: bold;
                            "
                          >
                            <v-select
                              v-model="item.j_chestwomens"
                              :items="j_chestwomensArray"
                              single-line
                              dense
                              label="-"
                              type="text"
                              class="ml-4 my-n1"
                              @change="selectChestW(item, index)"
                              :disabled="readOnly"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                      <!-- END WOMENS JACKET CHEST -->

                      <!-- START JACKET LENGTH -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.LENGTH }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;

                                color: #999999;
                              "
                            >
                              {{ item.j_lengthHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.j_length"
                                :disabled="readOnly"
                                type="number"
                                :min="j_lengthMin"
                                :max="j_lengthMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.j_qty == 0 ||
                                  (item.j_qty > 0 &&
                                    item.j_length &&
                                    item.j_length >= j_lengthMin &&
                                    item.j_length <= j_lengthMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- END JACKET LENGTH -->

                      <!-- START JACKET SLEEVE LENGTH -->
                      <!-- Nu trebuie sa apara SLEEVE LENGTH pentru modelele:BW01,BW01-M,BW01-CL -->
                      <v-col
                        v-show="
                          !['BW01', 'BW01-M', 'BW01-CL'].includes(j_model)
                        "
                      >
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.SLEEVELENGTH }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.j_sleeveLengthHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.j_sleeveLength"
                                :disabled="readOnly"
                                type="number"
                                :min="j_sleeveLengthMin"
                                :max="j_sleeveLengthMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.j_qty == 0 ||
                                  (item.j_qty > 0 &&
                                    item.j_sleeveLength &&
                                    item.j_sleeveLength >= j_sleeveLengthMin &&
                                    item.j_sleeveLength <= j_sleeveLengthMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- END JACKET SLEEVE LENGTH -->

                      <!-- START JACKET 1/2 WAIST -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;

                              color: white;
                            "
                          >
                            {{ trad.HALFWAIST }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.j_halfWaistHint }}
                            </div>

                            <!-- style="
                                margin-top: -8px;
                                width: 18px;
                                height: 18px;
                                text-align: center;
                                font-size: 25px;
                                font-weight: bold;
                              " -->

                            <button
                              @click.stop="item.j_halfWaist -= 1"
                              :disabled="item.j_halfWaist <= -4 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> - </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-minus
                              </v-icon>
                            </button>

                            <div
                              style="
                                width: 30px;
                                text-align: center;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-show="item.j_halfWaist > 0"
                                style="margin-right: -3px"
                              >
                                +
                              </span>
                              {{ item.j_halfWaist }}
                            </div>

                            <button
                              @click.stop="item.j_halfWaist += 1"
                              :disabled="item.j_halfWaist >= 6 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> + </span> -->

                              <v-icon size="18" color="#803135">
                                mdi-plus
                              </v-icon>
                            </button>
                          </div>
                        </div>
                      </v-col>
                      <!-- END JACKET 1/2 WAIST -->

                      <!-- START JACKET WOMENS 1/2 SEAT -->
                      <v-col v-if="womens">
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFSEAT }}
                          </div>

                          <div style="display: flex">
                            <!-- <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.j_halfWaistHint }}
                            </div> -->
                            <div
                              style="
                                width: 17px;
                                text-align: center;
                                color: #999999;
                              "
                            ></div>

                            <button
                              @click.stop="item.j_halfSeat -= 1"
                              :disabled="item.j_halfSeat <= -4 || readOnly"
                              style="width: 18px; height: 18px"
                            >
                              <!-- <span> - </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-minus
                              </v-icon>
                            </button>

                            <div
                              style="
                                width: 30px;
                                text-align: center;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-if="item.j_halfSeat > 0"
                                style="margin-right: -3px"
                              >
                                +
                              </span>
                              {{ item.j_halfSeat }}
                            </div>

                            <button
                              @click.stop="item.j_halfSeat += 1"
                              :disabled="item.j_halfSeat >= 6 || readOnly"
                              style="width: 18px; height: 18px"
                            >
                              <!-- <span> + </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-plus
                              </v-icon>
                            </button>
                          </div>
                        </div>
                      </v-col>

                      <!-- Nu trebuie sa apara SLEEVE LENGTH pentru modelele:BW01,BW01-M,BW01-CL -->
                      <!-- Completez coloana SLEEVE LENGTH ascunsa -->
                      <v-col
                        v-show="['BW01', 'BW01-M', 'BW01-CL'].includes(j_model)"
                      >
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>

                      <!-- END JACKET WOMENS 1/2 SEAT -->
                    </v-row>

                    <hr class="mr-n2" style="border-top: 1px solid #aaaaaa" />

                    <!-- END Linia 1 -->

                    <!-- _/\_/\_/\_/\_/\_/\_/\_/\_/\_/\_/\_ -->

                    <!-- START Linia 2 -->

                    <v-row style="height: 96px" class="mb-n8" v-if="t_model">
                      <v-col
                        :cols="womens ? 1 : 2"
                        style="
                          color: #803135;
                          font-size: 16px;
                          font-weight: bold;
                        "
                        class="my-3 mr-0 ml-4"
                      >
                        {{ trad.TROUSERS }}
                      </v-col>

                      <!-- START TROUSERS QUANTITY QTY -->
                      <v-col>
                        <div
                          class="mt-1 ml-6"
                          style="border: 2px solid #803135; width: 90px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.Quantity }}
                          </div>

                          <div>
                            <input
                              v-model="item.t_qty"
                              @change="corporateChanged"
                              :disabled="readOnly"
                              type="number"
                              min="0"
                              max="9999"
                              style="
                                width: 100%;
                                text-align: center;
                                font-weight: bold;
                                padding-left: 17px;
                              "
                              :style="
                                item.t_qty > 0 && item.t_qty < 10000
                                  ? ''
                                  : 'background-color: #fdbdbd;'
                              "
                            />
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS QUANTITY QTY -->

                      <!-- START TROUSERS SIZE -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.SIZE }}
                          </div>

                          <div
                            style="
                              width: 110px;
                              height: 25px;
                              text-align: center;
                              font-weight: bold;
                            "
                          >
                            <v-select
                              v-model="item.t_size"
                              :disabled="readOnly"
                              :items="t_sizeArray"
                              single-line
                              dense
                              label="-"
                              type="number"
                              class="ml-10 my-n1"
                              @change="selectSizeT(item, index)"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS SIZE -->

                      <!-- START TROUSERS LENGTH -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.LENGTH }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;

                                color: #999999;
                              "
                            >
                              {{ item.t_lengthHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.t_length"
                                :disabled="readOnly"
                                type="number"
                                :min="t_lengthMin"
                                :max="t_lengthMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.t_qty == 0 ||
                                  (item.t_qty > 0 &&
                                    item.t_length &&
                                    item.t_length >= t_lengthMin &&
                                    item.t_length <= t_lengthMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS LENGTH -->

                      <!-- START TROUSERS 1/2 WAIST -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFWAIST }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.t_halfWaistHint }}
                            </div>
                            <button
                              @click.stop="item.t_halfWaist -= 1"
                              :disabled="item.t_halfWaist <= -4 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> - </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-minus
                              </v-icon>
                            </button>

                            <div
                              style="
                                width: 30px;
                                text-align: center;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-if="item.t_halfWaist > 0"
                                style="margin-right: -3px"
                              >
                                +
                              </span>
                              {{ item.t_halfWaist }}
                            </div>

                            <button
                              @click.stop="item.t_halfWaist += 1"
                              :disabled="item.t_halfWaist >= 6 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> + </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-plus
                              </v-icon>
                            </button>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS 1/2 WAIST -->

                      <!-- START TROUSERS 1/2 BOTTOM -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFBOTTOM }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.t_halfBottomHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.t_halfBottom"
                                :disabled="readOnly"
                                type="number"
                                :min="t_halfBottomMin"
                                :max="t_halfBottomMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.t_qty == 0 ||
                                  (item.t_qty > 0 &&
                                    item.t_halfBottom &&
                                    item.t_halfBottom >= t_halfBottomMin &&
                                    item.t_halfBottom <= t_halfBottomMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>
                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>

                      <!-- END TROUSERS 1/2 BOTTOM -->
                    </v-row>

                    <!-- skirt -->
                    <v-row style="height: 96px" class="mb-n8" v-if="sk_model">
                      <v-col
                        :cols="womens ? 1 : 2"
                        style="
                          color: #803135;
                          font-size: 16px;
                          font-weight: bold;
                        "
                        class="my-3 mr-0 ml-4"
                      >
                        {{ trad.SKIRT }}
                      </v-col>

                      <!-- START SKIRT QUANTITY QTY -->
                      <v-col>
                        <div
                          class="mt-1 ml-6"
                          style="border: 2px solid #803135; width: 90px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.Quantity }}
                          </div>

                          <div>
                            <input
                              v-model="item.sk_qty"
                              @change="corporateChanged"
                              :disabled="readOnly"
                              type="number"
                              min="0"
                              max="9999"
                              style="
                                width: 100%;
                                text-align: center;
                                font-weight: bold;
                                padding-left: 17px;
                              "
                              :style="
                                item.sk_qty > 0 && item.sk_qty < 10000
                                  ? ''
                                  : 'background-color: #fdbdbd;'
                              "
                            />
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS QUANTITY QTY -->

                      <!-- START TROUSERS SIZE -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.SIZE }}
                          </div>

                          <div
                            style="
                              width: 110px;
                              height: 25px;
                              text-align: center;
                              font-weight: bold;
                            "
                          >
                            <v-select
                              v-model="item.sk_size"
                              :disabled="readOnly"
                              :items="sk_sizeArray"
                              single-line
                              dense
                              label="-"
                              type="number"
                              class="ml-10 my-n1"
                              @change="selectSizeSK(item, index)"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS SIZE -->

                      <!-- START TROUSERS LENGTH -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.LENGTH }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;

                                color: #999999;
                              "
                            >
                              {{ item.sk_lengthHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.sk_length"
                                :disabled="readOnly"
                                type="number"
                                :min="sk_lengthMin"
                                :max="sk_lengthMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.sk_qty == 0 ||
                                  (item.sk_qty > 0 &&
                                    item.sk_length &&
                                    item.sk_length >= sk_lengthMin &&
                                    item.sk_length <= sk_lengthMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS LENGTH -->

                      <!-- START TROUSERS 1/2 WAIST -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFWAIST }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.sk_halfWaistHint }}
                            </div>
                            <button
                              @click.stop="item.sk_halfWaist -= 1"
                              :disabled="item.sk_halfWaist <= -4 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> - </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-minus
                              </v-icon>
                            </button>

                            <div
                              style="
                                width: 30px;
                                text-align: center;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-if="item.sk_halfWaist > 0"
                                style="margin-right: -3px"
                              >
                                +
                              </span>
                              {{ item.sk_halfWaist }}
                            </div>

                            <button
                              @click.stop="item.sk_halfWaist += 1"
                              :disabled="item.sk_halfWaist >= 6 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> + </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-plus
                              </v-icon>
                            </button>
                          </div>
                        </div>
                      </v-col>
                      <!-- END TROUSERS 1/2 WAIST -->

                      <!-- START TROUSERS 1/2 BOTTOM -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFBOTTOM }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.sk_halfBottomHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.sk_halfBottom"
                                :disabled="readOnly"
                                type="number"
                                :min="sk_halfBottomMin"
                                :max="sk_halfBottomMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.sk_qty == 0 ||
                                  (item.sk_qty > 0 &&
                                    item.sk_halfBottom &&
                                    item.sk_halfBottom >= sk_halfBottomMin &&
                                    item.sk_halfBottom <= sk_halfBottomMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>
                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>

                      <!-- END TROUSERS 1/2 BOTTOM -->
                    </v-row>

                    <!-- end skirt -->
                    <hr class="mr-n2" style="border-top: 1px solid #aaaaaa" />

                    <!-- END Linia 2 -->

                    <!-- _/\_/\_/\_/\_/\_/\_/\_/\_/\_/\_/\_ -->

                    <!-- START Linia 3 -->

                    <v-row style="height: 96px" class="mb-n8" v-if="w_model">
                      <v-col
                        :cols="womens ? 1 : 2"
                        style="
                          color: #803135;
                          font-size: 16px;
                          font-weight: bold;
                        "
                        class="my-3 mr-0 ml-4"
                      >
                        {{ trad.WAISTCOAT }}
                      </v-col>

                      <!-- START WAISTCOAT QUANTITY QTY -->
                      <v-col>
                        <div
                          class="mt-1 ml-6"
                          style="border: 2px solid #803135; width: 90px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.Quantity }}
                          </div>

                          <div>
                            <input
                              v-model="item.w_qty"
                              @change="corporateChanged"
                              :disabled="readOnly"
                              type="number"
                              min="0"
                              max="9999"
                              style="
                                width: 100%;
                                text-align: center;
                                font-weight: bold;
                                padding-left: 17px;
                              "
                              :style="
                                item.w_qty > 0 && item.w_qty < 10000
                                  ? ''
                                  : 'background-color: #fdbdbd;'
                              "
                            />
                          </div>
                        </div>
                      </v-col>
                      <!-- END WAISTCOAT QUANTITY QTY -->

                      <!-- START WAISTCOAT SIZE -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.SIZE }}
                          </div>

                          <div
                            style="
                              width: 110px;
                              height: 25px;
                              text-align: center;
                              font-weight: bold;
                            "
                          >
                            <v-select
                              v-model="item.w_size"
                              :items="w_sizeArray"
                              :disabled="readOnly"
                              single-line
                              dense
                              label="-"
                              type="number"
                              class="ml-10 my-n1"
                              @change="selectSizeW(item, index)"
                            ></v-select>
                          </div>
                        </div>
                      </v-col>
                      <!-- END WAISTCOAT SIZE -->

                      <!-- START WAISTCOAT LENGTH -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.LENGTH }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.w_lengthHint }}
                            </div>

                            <div>
                              <input
                                v-model="item.w_length"
                                :disabled="readOnly"
                                type="number"
                                :min="w_lengthMin"
                                :max="w_lengthMax"
                                style="
                                  width: 75px;
                                  text-align: center;
                                  font-weight: bold;
                                "
                                :style="
                                  item.w_qty == 0 ||
                                  (item.w_qty > 0 &&
                                    item.w_length &&
                                    item.w_length >= w_lengthMin &&
                                    item.w_length <= w_lengthMax)
                                    ? ''
                                    : 'background-color: #fdbdbd;'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- END WAISTCOAT LENGTH -->

                      <!-- START WAISTCOAT 1/2 WAIST -->
                      <v-col>
                        <div
                          class="ma-1"
                          style="border: 2px solid #803135; width: 114px"
                        >
                          <div
                            style="
                              text-align: center;
                              border-bottom: 1px solid #803135;
                              background-color: #803135;
                              color: white;
                            "
                          >
                            {{ trad.HALFWAIST }}
                          </div>

                          <div style="display: flex">
                            <div
                              style="
                                width: 35px;
                                border-right: 1px solid #999999;
                                text-align: center;
                                color: #999999;
                              "
                            >
                              {{ item.w_halfWaistHint }}
                            </div>
                            <button
                              @click.stop="item.w_halfWaist -= 1"
                              :disabled="item.w_halfWaist <= -4 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> - </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-minus
                              </v-icon>
                            </button>

                            <div
                              style="
                                width: 30px;
                                text-align: center;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-if="item.w_halfWaist > 0"
                                style="margin-right: -3px"
                              >
                                +
                              </span>
                              {{ item.w_halfWaist }}
                            </div>

                            <button
                              @click.stop="item.w_halfWaist += 1"
                              :disabled="item.w_halfWaist >= 6 || readOnly"
                              class="btnPlusMinus"
                            >
                              <!-- <span> + </span> -->
                              <v-icon size="18" color="#803135">
                                mdi-plus
                              </v-icon>
                            </button>
                          </div>
                        </div>
                      </v-col>
                      <!-- END WAISTCOAT 1/2 WAIST -->

                      <v-col>
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>

                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>

                      <v-col v-if="womens">
                        <div class="ma-1" style="width: 114px"></div>
                      </v-col>
                    </v-row>
                    <!-- END Linia 3 -->
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogCustomerDelete" max-width="405px">
      <v-card>
        <v-card-title class="headline justify-center">
          <v-icon color="red" large class="mr-5"> mdi-alert </v-icon>
          {{ trad.DeleteCustomer }} ?
        </v-card-title>
        <v-card-title class="justify-center">{{ infoText }} </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            class="mr-8"
            @click="closeCustomerDelete"
          >
            {{ trad.Cancel }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            class="ml-8"
            @click="deleteCustomerConfirm"
          >
            {{ trad.OK }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Corporate",
  props: ["linkParams", "data"],

  data: () => ({
    // START DATA
    debug: false,
    developer: true,

    orderID: "",
    language: "en",
    AllData: "",
    readOnly: false,
    axiosTX: {},
    fetchError: false,
    loadingTable: false,
    loadingData: false,
    dialogCustomerDelete: false,
    infoText: "",

    customers: [],
    customersIsValid: false,
    activeCustomer: "", // customer activ, folosit la : Delete Customer

    j_model: "",
    j_sizeArray: [],
    j_chestwomensArray: [
      { text: "Normal", value: 800 },
      { text: "Light", value: 802 },
      { text: "Strong", value: 804 },
    ],
    j_lengthMin: 45,
    j_lengthMax: 120,
    j_sleeveLengthMin: 50,
    j_sleeveLengthMax: 82,

    t_model: "",
    t_sizeArray: [],
    t_lengthMin: 50,
    t_lengthMax: 120,
    t_halfBottomMin: 11,
    t_halfBottomMax: 35,

    sk_model: "",
    sk_sizeArray: [],
    sk_lengthMin: 1,
    sk_lengthMax: 120,
    sk_halfBottomMin: 1,
    sk_halfBottomMax: 60,

    w_model: "",
    w_sizeArray: [],
    w_lengthMin: 40,
    w_lengthMax: 70,

    womens: false,

    customersHeaders: [
      {
        text: "",
        align: "center",
        sortable: false,
        value: "",
      },
    ],

    // TRANSLATE VARIABLES
    trad: {
      Customers: "Customers",
      FirstName: "First Name",
      LastName: "Last Name",
      JACKET: "JACKET",
      TROUSERS: "TROUSERS",
      SKIRT: "SKIRT",
      WAISTCOAT: "WAISTCOAT",
      Quantity: "Quantity",
      SIZE: "SIZE",
      CHEST: "CHEST",
      LENGTH: "LENGTH",
      SLEEVELENGTH: "SLEEVE LENGTH",
      HALFWAIST: "1/2 WAIST",
      HALFSEAT: "1/2 SEAT",
      HALFBOTTOM: "1/2 BOTTOM",
      DeleteCustomer: "Delete Customer",
      OK: "OK",
      Cancel: "Cancel",
      NoData: "No data available",
      Loading: "Loading data",
    },
    // END DATA
  }),

  methods: {
    clickRowCustomers() {
      // clickRowCustomers(item, index) {
      // console.log("RowCustomers:", item, index);
    },

    debugInfo() {
      console.log(
        "%c[Debug Corporate]",
        "color:lime;background-color:blue;font-size:14px"
      );

      console.log("linkParams:", this.linkParams);
      console.log("data:", this.data);
      console.log("womens:", this.womens);

      console.log("j_model:", this.j_model);
      console.log("j_sizeArray:", this.j_sizeArray);
      console.log("t_model:", this.t_model);
      console.log("t_sizeArray:", this.t_sizeArray);
      console.log("w_model:", this.w_model);
      console.log("w_sizeArray:", this.w_sizeArray);
      console.log("sk_model:", this.sk_model);
      console.log("sk_sizeArray:", this.sk_sizeArray);
      console.log("customers:", this.customers);

      this.checkCustomers();
    },

    checkCustomers() {
      try {
        let valid = true;

        this.customers.forEach((item) => {
          // console.log("item:", item, "index:", index);
          if (!item.firstName) valid = false;

          // if (this.j_model != "" && this.j_model != "-") {
          if (this.j_model) {
            if (item.j_qty < 0 || item.j_qty == "") valid = false;

            if (item.j_qty > 0) {
              if (
                item.j_size == "" ||
                item.j_length == "" ||
                item.j_sleeveLength == ""
              )
                valid = false;

              if (
                item.j_length < this.j_lengthMin ||
                item.j_length > this.j_lengthMax ||
                item.j_sleeveLength < this.j_sleeveLengthMin ||
                item.j_sleeveLength > this.j_sleeveLengthMax
              )
                valid = false;
            }
          }

          // if (this.t_model != "" && this.t_model != "-") {
          if (this.t_model) {
            if (item.t_qty < 0 || item.t_qty == "") valid = false;

            if (item.t_qty > 0) {
              if (
                item.t_size == "" ||
                item.t_length == "" ||
                item.t_halfBottom == ""
              )
                valid = false;

              if (
                item.t_length < this.t_lengthMin ||
                item.t_length > this.t_lengthMax ||
                item.t_halfBottom < this.t_halfBottomMin ||
                item.t_halfBottom > this.t_halfBottomMax
              )
                valid = false;
            }
          }

             // if (this.t_model != "" && this.t_model != "-") {
          if (this.sk_model) {
            if (item.sk_qty < 0 || item.sk_qty == "") valid = false;

            if (item.sk_qty > 0) {
              if (
                item.sk_size == "" ||
                item.sk_length == "" ||
                item.sk_halfBottom == ""
              )
                valid = false;

              if (
                item.sk_length < this.sk_lengthMin ||
                item.sk_length > this.sk_lengthMax ||
                item.sk_halfBottom < this.sk_halfBottomMin ||
                item.sk_halfBottom > this.sk_halfBottomMax
              )
                valid = false;
            }
          }

          // if (this.w_model != "" && this.w_model != "-") {
          if (this.w_model) {
            if (item.w_qty < 0 || item.w_qty == "") valid = false;

            if (item.w_qty > 0) {
              if (item.w_size == "" || item.w_length == "") valid = false;

              if (
                item.w_length < this.w_lengthMin ||
                item.w_length > this.w_lengthMax
              )
                valid = false;
            }
          }
        });

        if (this.customers.length) this.customersIsValid = valid;
        else this.customersIsValid = false;
      } catch (err) {
        console.log("Critical Error la checkCustomers:", err);
        this.customersIsValid = false;
      }

      console.log("\x1b[32m%s", "CUSTOMERS CHECK:", this.customersIsValid);
    },

    addCustomer() {
      console.log("Add Customer:");
      this.customers.push({
        firstName: "",
        lastName: "",

        j_qty: 0,
        j_size: "",
        j_sizeArray: this.j_sizeArray,
        j_chestwomens: 800,
        j_lengthHint: "",
        j_length: "",
        j_sleeveLengthHint: "",
        j_sleeveLength: "",
        j_halfWaistHint: "",
        j_halfWaist: 0,
        j_halfSeat: 0,

        t_qty: 0,
        t_size: "",
        t_sizeArray: this.t_sizeArray,
        t_lengthHint: "",
        t_length: "",
        t_halfWaistHint: "",
        t_halfWaist: 0,
        t_halfBottomHint: "",
        t_halfBottom: "",

        sk_qty: 0,
        sk_size: "",
        sk_sizeArray: this.sk_sizeArray,
        sk_lengthHint: "",
        sk_length: "",
        sk_halfWaistHint: "",
        sk_halfWaist: 0,
        sk_halfBottomHint: "",
        sk_halfBottom: "",

        w_qty: 0,
        w_size: "",
        w_sizeArray: this.w_sizeArray,
        w_lengthHint: "",
        w_length: "",
        w_halfWaistHint: "",
        w_halfWaist: 0,
      });
    },

    selectChestW(item, index) {
      console.log("\x1b[32m%s", "[selectChestW]:", index, item);
    },

    async selectSizeJ(item, index) {
      console.log("\x1b[32m%s", "[selectSize J]:", index, item);

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/ajaxsacoumasuri?modelNo=${this.j_model}&size=${item.j_size}&alterations=&CodeAtitude=&CodeEpauleG=&CodeEpauleD=&CodePoitrine=&LungSpate=&LungManSt=&LungManDr=&Slit=&SlitDif=&Buton1=&Buton1Dif=`,
      };

      let response = await this.axios("selectSizeJ");
      console.log("\x1b[35m%s", "[Axios RX selectSize J]:", response.data);

      if (response.status == 200) {
        this.customers[index].j_lengthHint = Number(
          response.data.HMILDOS.GAB
        ).toFixed(1);
        this.customers[index].j_lengthHint = "";

        this.customers[index].j_sleeveLengthHint = Number(
          response.data.LONGMANDR.GAB
        ).toFixed(1);

        this.customers[index].j_halfWaistHint = Number(
          response.data.TAILLE.GAB
        ).toFixed(1);
      } else {
        console.log("selectSize J AXIOS Error");
        this.customers[index].j_lengthHint = "";
        this.customers[index].j_sleeveLengthHint = "";
        this.customers[index].j_halfWaistHint = "";
      }

      // https://b2b.formens.ro/mtmoptions/ajaxsacoumasuri?modelNo=G16&size=42&alterations=&CodeAtitude=400&CodeEpauleG=500&CodeEpauleD=600&CodePoitrine=800&LungSpate=&LungManSt=&LungManDr=&Slit=24&SlitDif=&Buton1=40&Buton1Dif=
    },

    async selectSizeT(item, index) {
      console.log("\x1b[32m%s", "[selectSize T]:", index, item);

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/ajaxpantmasuri?modelNo=${this.t_model}&demiTaille=&size=${item.t_size}&alterations=&demiBas=&terminatie=-&pliuriFata=-&entrejambe=&entrejambe_st=&longueurcote=&longueurcote_st=`,
      };

      let response = await this.axios("selectSizeT");
      console.log("\x1b[35m%s", "[Axios RX selectSize T]:", response.data);

      if (response.status == 200) {
        this.customers[index].t_lengthHint = Number(
          response.data.ENTREJAMBE.GAB
        ).toFixed(1);

        this.customers[index].t_halfWaistHint = Number(
          response.data.TAILLE.GAB
        ).toFixed(1);

        this.customers[index].t_halfBottomHint = Number(
          response.data.BAS.GAB
        ).toFixed(1);
      } else {
        console.log("selectSize T AXIOS Error");
        this.customers[index].t_lengthHint = "";
        this.customers[index].t_halfWaistHint = "";
        this.customers[index].t_halfBottomHint = "";
      }
    },


    async selectSizeSK(item, index) {
      console.log("\x1b[32m%s", "[selectSize SK]:", index, item);

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/ajaxpantmasuri?modelNo=${this.sk_model}&demiTaille=&size=${item.sk_size}&alterations=&demiBas=&terminatie=-&pliuriFata=-&entrejambe=&entrejambe_st=&longueurcote=&longueurcote_st=`,
      };

      let response = await this.axios("selectSizeSK");
      console.log("\x1b[35m%s", "[Axios RX selectSize SK]:", response.data);

      if (response.status == 200) {
        this.customers[index].sk_lengthHint = Number(
          response.data.ENTREJAMBE.GAB
        ).toFixed(1);

        this.customers[index].sk_halfWaistHint = Number(
          response.data.TAILLE.GAB
        ).toFixed(1);

        this.customers[index].sk_halfBottomHint = Number(
          response.data.BAS.GAB
        ).toFixed(1);
      } else {
        console.log("selectSize SK AXIOS Error");
        this.customers[index].sk_lengthHint = "";
        this.customers[index].sk_halfWaistHint = "";
        this.customers[index].sk_halfBottomHint = "";
      }
    },


    async selectSizeW(item, index) {
      console.log("\x1b[32m%s", "[selectSize W]:", index, item);

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/ajaxvestamasuri?modelNo=${this.w_model}&size=${item.w_size}&alterations=&GLungSpate=&Gouverture=`,
      };

      let response = await this.axios("selectSizeW");
      console.log("\x1b[35m%s", "[Axios RX selectSize W]:", response.data);

      if (response.status == 200) {
        this.customers[index].w_lengthHint = Number(
          response.data.HMILDOS.GAB
        ).toFixed(1);

        this.customers[index].w_halfWaistHint = Number(
          response.data.TAILLE.GAB
        ).toFixed(1);
      } else {
        console.log("selectSize W AXIOS Error");
        this.customers[index].w_lengthHint = "";
        this.customers[index].w_halfWaistHint = "";
      }
    },

    async axios(origin) {
      console.log(
        "\x1b[35m%s",
        `[Axios TX ${origin}]:`,
        JSON.stringify(this.axiosTX)
      );

      return await axios(this.axiosTX)
        .then((response) => {
          // console.log("RX:", response);
          return response;
        })
        .catch((error) => {
          // console.log("ERR:", error);
          return error;
        });
    },

    deleteCustomer(index) {
      console.log("\x1b[32m%s", "Delete Customer:", index);
      this.activeCustomer = index; // index din array al customerului selectat

      this.infoText = this.customers[index].firstName;
      this.infoText += " ";
      this.infoText += this.customers[index].lastName;

      this.customers[index].firstName;
      this.dialogCustomerDelete = true;
    },

    closeCustomerDelete() {
      console.log("[deleteCustomer Cancel]:", this.activeCustomer);
      this.dialogCustomerDelete = false;
      this.activeCustomer = "";
      this.infoText = "";
    },

    deleteCustomerConfirm() {
      console.log("[deleteCustomer Confirm]:", this.activeCustomer);
      this.customers.splice(this.activeCustomer, 1);
      this.dialogCustomerDelete = false;
      this.activeCustomer = "";
      this.infoText = "";
    },

    injectDebugData(value) {
      this.womens = true;

      if (value == "BW01-CL") this.j_model = "BW01-CL";
      else this.j_model = "MG102";
      this.j_sizeArray = [
        42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70,
      ];

      this.t_model = "5PB";
      this.t_sizeArray = [34, 35, 36, 37, 38, 29, 30, 31, 32, 33];

      this.w_model = "GFETOX";
      this.w_sizeArray = ["AUTO", 34, 36, 38, 40, 42, 44, 46, 48, 50, 52];

      this.customers = [
        {
          firstName: "Ionescu",
          lastName: "Vasile",

          j_qty: 1,
          j_size: 42,
          j_chestwomens: 800,
          // j_lengthHint: 92.5,
          j_lengthHint: "",
          j_length: "",
          j_sleeveLengthHint: 65,
          j_sleeveLength: "",
          j_halfWaistHint: 45,
          j_halfWaist: 0,
          j_halfSeat: 0,

          t_qty: 2,
          t_size: 34,
          t_lengthHint: 84,
          t_length: "",
          t_halfWaistHint: 45,
          t_halfWaist: 0,
          t_halfBottomHint: 18.5,
          t_halfBottom: "",

          w_qty: 3,
          w_size: 34,
          w_lengthHint: 48.5,
          w_length: "",
          w_halfWaistHint: 36,
          w_halfWaist: 0,
        },
        {
          firstName: "Mihai",
          lastName: "Petrica",

          j_qty: 1,
          j_size: 70,
          j_chestwomens: 804,
          // j_lengthHint: 11.1,
          j_lengthHint: "",
          j_length: "",
          j_sleeveLengthHint: 12.2,
          j_sleeveLength: "",
          j_halfWaistHint: 13.3,
          j_halfWaist: 0,
          j_halfSeat: 0,

          t_qty: 2,
          t_size: 72,
          t_lengthHint: 21.1,
          t_length: "",
          t_halfWaistHint: 22.2,
          t_halfWaist: 0,
          t_halfBottomHint: 23.3,
          t_halfBottom: "",

          w_qty: 3,
          w_size: 74,
          w_lengthHint: 31.1,
          w_length: "",
          w_halfWaistHint: 32.2,
          w_halfWaist: 0,
        },
      ];
    },

    async translate() {
      console.log("\x1b[32m%s", "[Translate]");

      let payload = {
        language: this.language,
        words: Object.values(this.trad),
      };

      this.axiosTX = {
        method: "post",
        url: `https://node.formens.ro/translate`,
        data: payload,
      };

      let response = await this.axios(`translate [${this.language}]`);
      console.log(
        "\x1b[35m%s",
        `[Axios RX Translate [${this.language}]]:`,
        response.data
      );

      if (response.status == 200) {
        Object.entries(this.trad).forEach((item, index) => {
          this.trad[item[0]] = response.data.words[index];
        });
      } else {
        console.log("Translate AXIOS Error");
      }
    },

    corporateChanged() {
      console.log("Send [C] updates Vue => B2B");

      let data = {
        j_model: this.j_model || "",
        j_sizeArray: this.j_sizeArray,
        t_model: this.t_model || "",
        t_sizeArray: this.t_sizeArray,
        sk_model: this.sk_model || "",
        sk_sizeArray: this.sk_sizeArray,
        w_model: this.w_model || "",
        w_sizeArray: this.w_sizeArray,

        womens: this.womens,
        customers: this.customers,
      };

      let dataToPostMesage = {
        from: "corporateUpdate",
        data: data,
        // customers: this.customers,
        // orderid: this.orderID,
        type: "corporateUpdate",
      };
      this.$emit("corporateEmit", dataToPostMesage);
    },

    async getAllSizes() {
      console.log(
        "%c[getAllSizes]",
        "color:lime;background-color:blue;font-size:14px",
        JSON.stringify(this.customers)
      );

      this.loadingData = true;

      let jacket = false,
        trousers = false,
        skirt = false,
        waistcoat = false;

      // daca dai click in stanga pe Customers, ai debug cu this.customers
      this.customers = [...this.customers];
      this.customers.forEach((e) => {
        if (e.j_size !== "") jacket = true;
        if (e.t_size !== "") trousers = true;
        if (e.sk_size !== "") skirt = true;
        if (e.w_size !== "") waistcoat = true;
      });

      console.log("JKT:", jacket, "TRS:", trousers, "WAIST:", waistcoat);

      // START UPDATE HINT JACKET
      if (jacket) {
        // replace Hints with '?'
        this.customers.forEach((e, index) => {
          if (e.j_size !== "") {
            // this.customers[index].j_lengthHint = "?";
            this.customers[index].j_lengthHint = "";
            this.customers[index].j_sleeveLengthHint = "?";
            this.customers[index].j_halfWaistHint = "?";
          }
        });

        let link = `https://b2b2.formens.ro/mtmoptions/ajaxsacoumasuriall?modelNo=${this.j_model}`;
        this.axiosTX = {
          method: "GET",
          url: link,
        };

        let response = await this.axios("JKT getAllSizes");
        console.log("\x1b[35m%s", "[Axios RX JKT getAllSizes]:", response.data);

        if (response.status == 200 && Object.keys(response.data).length) {
          console.log(`*** Lista J [${this.customers.length}] Customeri ***`);
          this.customers.forEach((e, index) => {
            // marimea aleasa este in array ? (poate sa nu mai fie daca schimba base-ul)
            if (e.j_size !== "" && this.j_sizeArray.includes(e.j_size)) {
              let size = this.customers[index].j_size;
              console.log(`J Client [${index}] SIZE:`, size, e);
              // this.customers[index].j_lengthHint = Number(response.data[size].HMILDOS.GAB).toFixed(1);
              this.customers[index].j_lengthHint = "";

              this.customers[index].j_sleeveLengthHint = Number(
                response.data[size].LONGMANDR.GAB
              ).toFixed(1);

              this.customers[index].j_halfWaistHint = Number(
                response.data[size].TAILLE.GAB
              ).toFixed(1);
            }
          });
        }
      }
      // END UPDATE HINT JACKET

      // START UPDATE HINT TROUSERS
      if (trousers) {
        // replace Hints with '?'
        this.customers.forEach((e, index) => {
          if (e.t_size !== "") {
            this.customers[index].t_lengthHint = "?";
            this.customers[index].t_halfWaistHint = "?";
            this.customers[index].t_halfBottomHint = "?";
          }
        });

        let link = `https://b2b2.formens.ro/mtmoptions/ajaxpantmasuriall?modelNo=${this.t_model}`;
        this.axiosTX = {
          method: "GET",
          url: link,
        };

        let response = await this.axios("TRS getAllSizes");
        console.log("\x1b[35m%s", "[Axios RX TRS getAllSizes]:", response.data);

        if (response.status == 200 && Object.keys(response.data).length) {
          console.log(`*** Lista T [${this.customers.length}] Customeri ***`);
          this.customers.forEach((e, index) => {
            // marimea aleasa este in array ? (poate sa nu mai fie daca schimba base-ul)
            if (e.t_size !== "" && this.t_sizeArray.includes(e.t_size)) {
              let size = this.customers[index].t_size;
              console.log(`T Client [${index}] SIZE:`, size, e);
              // console.log("response.data[size]:", response.data[size]);
              this.customers[index].t_lengthHint = Number(
                response.data[size].ENTREJAMBE.GAB
              ).toFixed(1);

              this.customers[index].t_halfWaistHint = Number(
                response.data[size].TAILLE.GAB
              ).toFixed(1);

              this.customers[index].t_halfBottomHint = Number(
                response.data[size].BAS.GAB
              ).toFixed(1);
            }
          });
        }
      }
      // END UPDATE HINT TROUSERS

         // START UPDATE HINT SKIRT
      if (skirt) {
        // replace Hints with '?'
        this.customers.forEach((e, index) => {
          if (e.t_size !== "") {
            this.customers[index].sk_lengthHint = "?";
            this.customers[index].sk_halfWaistHint = "?";
            this.customers[index].sk_halfBottomHint = "?";
          }
        });

        let link = `https://b2b2.formens.ro/mtmoptions/ajaxpantmasuriall?modelNo=${this.sk_model}`;
        this.axiosTX = {
          method: "GET",
          url: link,
        };

        let response = await this.axios("SK getAllSizes");
        console.log("\x1b[35m%s", "[Axios RX SK getAllSizes]:", response.data);

        if (response.status == 200 && Object.keys(response.data).length) {
          console.log(`*** Lista SK [${this.customers.length}] Customeri ***`);
          this.customers.forEach((e, index) => {
            // marimea aleasa este in array ? (poate sa nu mai fie daca schimba base-ul)
            if (e.sk_size !== "" && this.sk_sizeArray.includes(e.sk_size)) {
              let size = this.customers[index].sk_size;
              console.log(`SK Client [${index}] SIZE:`, size, e);
              // console.log("response.data[size]:", response.data[size]);
              this.customers[index].sk_lengthHint = Number(
                response.data[size].ENTREJAMBE.GAB
              ).toFixed(1);

              this.customers[index].sk_halfWaistHint = Number(
                response.data[size].TAILLE.GAB
              ).toFixed(1);

              this.customers[index].sk_halfBottomHint = Number(
                response.data[size].BAS.GAB
              ).toFixed(1);
            }
          });
        }
      }
      // END UPDATE HINT TROUSERS

      // START UPDATE HINT WAISTCOAT
      if (waistcoat) {
        // replace Hints with '?'
        this.customers.forEach((e, index) => {
          if (e.w_size !== "") {
            this.customers[index].w_lengthHint = "?";
            this.customers[index].w_halfWaistHint = "?";
          }
        });

        let link = `https://b2b2.formens.ro/mtmoptions/ajaxvestamasuriall?modelNo=${this.w_model}`;
        this.axiosTX = {
          method: "GET",
          url: link,
        };

        let response = await this.axios("WAIST getAllSizes");
        console.log(
          "\x1b[35m%s",
          "[Axios RX WAIST getAllSizes]:",
          response.data
        );

        if (response.status == 200 && Object.keys(response.data).length) {
          console.log(`*** Lista W [${this.customers.length}] Customeri ***`);
          this.customers.forEach((e, index) => {
            // marimea aleasa este in array ? (poate sa nu mai fie daca schimba base-ul)
            if (e.w_size !== "" && this.w_sizeArray.includes(e.w_size)) {
              let size = this.customers[index].w_size;
              console.log(`W Client [${index}] SIZE:`, size, e);

              // console.log(
              //   `response.data[size][${index}]:`,
              //   response.data[size]
              // );
              this.customers[index].w_lengthHint = Number(
                response.data[size].HMILDOS.GAB
              ).toFixed(1);

              this.customers[index].w_halfWaistHint = Number(
                response.data[size].TAILLE.GAB
              ).toFixed(1);
            }
          });
        }
      }

      this.loadingData = false;

      // END UPDATE HINT WAISTCOAT
    },

    async saveOrder() {
      console.log("\x1b[32m%s", "[corporateSaveOrder]:", this.orderID);
      if (this.orderID === undefined) {
        if (this.orderID > 1634016748449) this.orderID = Date.now();
        console.log("\x1b[32m%s", "[NewTimeStampOrder]:", this.orderID);
      }

      let data = {
        j_model: this.j_model || "",
        j_sizeArray: this.j_sizeArray,
        t_model: this.t_model || "",
        t_sizeArray: this.t_sizeArray,
        sk_model: this.sk_model || "",
        sk_sizeArray: this.sk_sizeArray,
        w_model: this.w_model || "",
        w_sizeArray: this.w_sizeArray,

        womens: this.womens,
        customers: this.customers,
        orderID: this.orderID,
        AllData: this.AllData,
        language: this.language,
      };

      let payload = {
        type: "saveCorporate",
        orderID: this.orderID,
        data,
        timeStamp: Date.now(),
      };

      this.axiosTX = {
        method: "post",
        url: `https://ait.formens.ro/b2bFiles/`, // FMS23, local C:/B2B/Files/
        headers: {},
        data: payload,
      };

      let response = await this.axios(`Save [C] orderID [${this.orderID}]`);
      console.log(
        "\x1b[35m%s",
        `[Axios [C] RX Save Order [${this.orderID}]]:`,
        response.data
      );

      if (response.status == 200)
        console.log(`[C] Save OK Order: ${this.orderID}`);
      else console.log(`[C] Save FAIL Order: ${this.orderID}`);

      let dataToPostMesage = {
        from: "corporateGet",
        orderid: this.orderID,
        type: "SaveOrder",
        status: response.status == 200 ? true : false,
      };
      this.$emit("corporateEmit", dataToPostMesage);
    },

    async loadOrder() {
      console.log("\x1b[32m%s", "[corporateLoadOrder]:", this.orderID);

      if (this.orderID === undefined) return;

      let payload = {
        type: "loadCorporate",
        orderID: this.orderID,
        debug: {
          linkParams: this.linkParams,
          // customers: this.customers, inca nu am date, se formeaza in node-red
        },
      };

      this.axiosTX = {
        method: "post",
        url: `https://ait.formens.ro/b2bFiles`, // FMS23, local C:/B2B/Files/
        data: payload,
      };

      const axiosRX = await this.axios(`Load [C] orderID [${this.orderID}]`);
      console.log(
        "\x1b[35m%s",
        `[Axios [C] RX Load Order [${this.orderID}]]:`,
        axiosRX.data
      );

      if (axiosRX.status == 200) {
        this.womens = axiosRX.data.womens || false;

        this.j_model = axiosRX.data.j_model || "";
        this.j_sizeArray = axiosRX.data.j_sizeArray || [];

        this.t_model = axiosRX.data.t_model || "";
        this.t_sizeArray = axiosRX.data.t_sizeArray || [];

        this.sk_model = axiosRX.data.sk_model || "";
        this.sk_sizeArray = axiosRX.data.sk_sizeArray || [];

        this.w_model = axiosRX.data.w_model || "";
        this.w_sizeArray = axiosRX.data.w_sizeArray || [];

        this.customers = axiosRX.data.customers || [];

        console.log(
          `[C] Load OK Order: ${this.orderID}`,
          "Customer:",
          this.customers
        );
      } else console.log(`[C] Load FAIL Order: ${this.orderID}`);
    },
  },

  watch: {
    data: async function (allData) {
      console.log("WATCH data [C] TRIGGER", allData);
      this.AllData = allData;
      // allData sample =  {"type": "corporateSave", "data": "W658670"}

      if (!this.customers.length) await this.loadOrder(); // inca nu am date in customers

      // probabil mai primesc si alte date, folosite doar la <serii>
      // MSG  message from B2B -> App.vue > Corporate.vue

      if (allData.type == "corporateSend") {
        this.womens = allData.data.womens || false;

        this.j_model = allData.data.j_model || "";
        if (this.j_model == "-" || this.j_model == "--") this.j_model = ""; // corectie
        this.j_sizeArray = allData.data.j_sizeArray || [];

        this.t_model = allData.data.t_model || "";
        if (this.t_model == "-" || this.t_model == "--") this.t_model = ""; // corectie
        this.t_sizeArray = allData.data.t_sizeArray || [];

        this.sk_model = allData.data.sk_model || "";
        if (this.sk_model == "-" || this.sk_model == "--") this.sk_model = ""; // corectie
        this.sk_sizeArray = allData.data.sk_sizeArray || [];

        this.w_model = allData.data.w_model || "";
        if (this.w_model == "-" || this.w_model == "--") this.w_model = ""; // corectie
        this.w_sizeArray = allData.data.w_sizeArray || [];

        // doar daca primesc si model (MSG complet)
        if (this.j_model || this.t_model || this.w_model) {
          // actualizez all Customers [j,t,w]_sizeArray, altfel fiecare client ar avea
          // _sizeArray diferite (functie de baseModel, generate cu push la creare new Customer)
          for (const i in this.customers) {
            this.customers[i].j_sizeArray = this.j_sizeArray;
            this.customers[i].t_sizeArray = this.t_sizeArray;
            this.customers[i].sk_sizeArray = this.sk_sizeArray;
            this.customers[i].w_sizeArray = this.w_sizeArray;
          }

          console.log("Before GAZ:", this.customers);

          this.getAllSizes();
        }
      }

      if (allData.type == "corporateSave") {
        let orderID = allData.data || "";
        orderID = Number(orderID.replace("W", "")) - 10000;
        this.orderID = orderID;
        console.log("[C] orderID - 10K :", this.orderID);

        this.saveOrder();
      }

      if (allData.type == "corporateGet") {

        console.log("aaa")
        // STEP 1 : check data
        this.checkCustomers();

        // STEP 2 : prepare data
        let dataToPostMesage = {
          from: "corporateGet",
          customers: this.customers,
          customersIsValid: this.customersIsValid,
        };

        // STEP 3 : send data
        this.$emit("corporateEmit", dataToPostMesage);
      }
    },
  },

  async mounted() {},

  async created() {
    console.log(
      `%c[CorporateB2B Created]`,
      "color:yellow;background-color:blue;font-size:14px"
    );

    if (this.linkParams.readonly == 1) this.readOnly = true;
    else this.readOnly = false;

    this.developer = process.env.NODE_ENV;
    if (process.env.NODE_ENV == "development") this.developer = true;
    else this.developer = false;

    this.orderID = this.linkParams.orderid;
    console.log("[C] orderID:", this.orderID);

    if ("language" in this.linkParams) this.language = this.linkParams.language;
    else this.language = "en";
    await this.translate();
  },
};
</script>

<style scoped>
td {
  border: solid;
  border-width: 2px 0;
}

table {
  border-collapse: collapse;
}

.btnPlusMinus {
  width: 18px;
  height: 18px;
  font-weight: bold;
  cursor: pointer;
}
</style>
